import { Component, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconContainer } from '@navfleet/client/shared/components/icon/ui';
import { Tenant } from '@navfleet/client/tenant/domain/models';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { Button } from '@openng/optimus-ui/button';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';
import { Select } from '@openng/optimus-ui/select';

@Component({
    imports: [TranslationModule, FormsModule, Button, Select, ProgressSpinner, IconContainer],
    selector: 'fl-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    public readonly isAuthenticated = input.required<boolean | null>();
    public readonly isLoading = input(false);
    public readonly tenants = input<Tenant[]>([]);
    public readonly version = input<string>();
    public readonly tenantLogin = output<Tenant>();
    public readonly logout = output();

    public readonly selectedTenant = signal<Tenant | undefined>(undefined);

    public onLoginClick() {
        const tenant = this.selectedTenant();
        if (!tenant) {
            return;
        }
        this.tenantLogin.emit(tenant);
    }
}
